import React, { Suspense } from "react";
import { SpeciesEnum } from "../../../../../__generated__/globalTypes";
import ChatMessage, {
  ChatContainer,
} from "../../../../ui-kit/ChatMessage/ChatMessage";
import { Typography } from "../../../../ui-kit/Typography";
import Gutter from "../../../../ui-kit/Gutter";
import { useWebTranslation } from "../../../../translations";
import {
  updateAnimalById,
  updateInsuranceById,
} from "components/Signup/store/slices/animals";
import { StepProps } from "../types";
import { useSignupDispatch } from "components/Signup/store/hooks";
import {
  useAllValidAnimals,
  useCurrentAnimal,
} from "components/Signup/store/selectors/animals";
import { useCurrentInsuranceByAnimalId } from "components/Signup/store/selectors/insurance";
import { getGermanDefaultHealthIsuranceSettings } from "components/Signup/store/state/utils";
import { isOrg } from "utils/site";
import { MultipetDisclaimer } from "components/Signup/components/MultipetDisclaimer";

const AnimalSpecies = ({ transitioning, next }: StepProps) => {
  const { t } = useWebTranslation();
  const dispatch = useSignupDispatch();
  const animal = useCurrentAnimal();
  const { id: insuranceID } = useCurrentInsuranceByAnimalId(animal.id);
  const animals = useAllValidAnimals();

  const species = [
    {
      label: t("global.dog"),
      value: SpeciesEnum.dog,
    },
    {
      label: t("global.cat"),
      value: SpeciesEnum.cat,
    },
  ];

  return (
    <Suspense>
      <ChatContainer leaving={transitioning}>
        <ChatMessage index={1}>
          <Typography>{t("signup.species.text")}</Typography>
        </ChatMessage>
        <Gutter size={2} />
        {species.map((item, index) => (
          <ChatMessage
            key={item.value}
            blink
            fromMe
            data-testid={item.label}
            index={index + 2}
            onPress={() => {
              if (isOrg("ger") && item.value === SpeciesEnum.cat) {
                dispatch(
                  updateInsuranceById(
                    {
                      id: insuranceID,
                      update: getGermanDefaultHealthIsuranceSettings(),
                    },
                    { refetch: false }
                  )
                );
              }

              dispatch(
                updateAnimalById({
                  id: animal.id,
                  update: {
                    species: item.value,
                    ...(item.value !== animal.species && {
                      breed: null,
                      mixedBreedFHalf: null,
                      mixedBreedSHalf: null,
                    }),
                  },
                })
              );
              next && next();
            }}
            active={animal.species === item.value}
          >
            <Typography>
              {`${item.value === SpeciesEnum.dog ? "🐶" : "🐱"} ${item.label}`}
            </Typography>
          </ChatMessage>
        ))}
        {!isOrg("swe") && animals.length === 0 ? <MultipetDisclaimer /> : null}
      </ChatContainer>
    </Suspense>
  );
};

export default AnimalSpecies;
